import React from 'react';

const PartnerDetails: React.FC<any> = (props) => {
  const { data, refresh } = props

  return (
    <div>
      {/* data.pictures && data.pictures.length &&
        <div>
          {data.pictures.map((item, index) => (
            <div key={index} style={{display: 'inline-block'}}>
              <img src={item} style={{width: 80, height: 80,}} />
            </div>
          ))}
        </div>
      */}
      <div>{data.description}</div>
      <div><br />Contactez notre partenaire via email: {data.mail}</div>
    </div>
  )
}

export default PartnerDetails